import LTR from "@brand-icons/ploom/basket/basket-ltr.svg";

import { iconFactory } from "../iconFactory";

export const BasketIcon = iconFactory("BasketIcon", LTR);
